import { Text } from '@pm/ui';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

type AppointmentTimeZoneProps = {
  date: Date;
  size?: ComponentProps<typeof Text>['size'];
};

export const AppointmentTimeZone = ({
  date,
  size = 'label',
}: AppointmentTimeZoneProps) => {
  const { t } = useTranslation('appointments', {
    keyPrefix: 'Appointment.Summary',
  });

  const timeZoneWithOffset = t('AppointmentTimeZone', { date });

  return (
    <div className="flex space-x-s items-center">
      <Text
        size={size}
        color="contentSubdued"
        as="time"
        role="time"
        dateTime={date.toDateString()}
        title={timeZoneWithOffset}
      >
        {timeZoneWithOffset}
      </Text>
    </div>
  );
};
